import OutOfTermClassroomModal from '@/components/common/OutOfTermClassroomModal/OutOfTermClassroomModal';

export default OutOfTermClassroomModal;
